export default __webpack_public_path__ + "static/media/comm 11.a81ed81d.jpeg";